import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1FCE6D",
      fillRule: "evenodd",
      d: "M16 0v32c-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M16 32V0c3.75.033 7.567.432 9.69 1.263 4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M22.052 10.583a6.77 6.77 0 0 0-3.934-1.25c-3.725 0-6.745 2.985-6.745 6.667s3.02 6.667 6.745 6.667a6.77 6.77 0 0 0 3.934-1.25A8.12 8.12 0 0 1 16.095 24C11.625 24 8 20.418 8 16s3.624-8 8.095-8c2.356 0 4.478.995 5.957 2.583m-3.33 6.752-2.537.752 1.508-2.152-1.523-2.163 2.543.77 1.596-2.09.063 2.629 2.51.872-2.504.854-.045 2.628z",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagDza = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagDza_default = SvgFlagDza;

export { FlagDza_default as default };
